module.exports = __webpack_public_path__ + "static/media/pic1.2883e757.jpeg";